import { Stack } from '@chakra-ui/react';
import { identitySystemOptions } from '@pelicargo/utils';

import { SimpleInput } from '../SimpleInput';
import { SimpleSelect } from '../SimpleSelect';

type Props = {
  prefix: string;
  isFirst: boolean;
  isLast: boolean;
  hasMultiple: boolean;
};

export const ProviderIdentityMapForm = ({ prefix }: Props) => {
  return (
    <>
      <Stack direction="column" spacing="4" w="full" borderWidth={1} p={2} borderRadius="md">
        <SimpleInput name={`${prefix}.id`} hidden />
        <Stack direction="row">
          <SimpleSelect name={`${prefix}.system`} label="System Type" options={identitySystemOptions} flex={1} />
          <SimpleInput
            name={`${prefix}.value`}
            label="Value"
            helper="This is the ID coming from the provider that we want to map (e.g. a specific airline code)."
            flex={3}
          />
        </Stack>
      </Stack>
    </>
  );
};
